<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="price$ | async as price; else strategyPrice"> {{ price }}</ng-container>

  <ng-template #strategyPrice>
    <ng-container *ngIf="strategy === 'flat'">$ {{ amount }} <ng-container i18n>per month</ng-container></ng-container>
    <ng-container *ngIf="strategy === 'per-rental'"
      >$ {{ amount }} <ng-container i18n>per rental per month</ng-container>
    </ng-container>
    <ng-container *ngIf="strategy === 'rental-brackets'"
      >$ {{ amount }} <ng-container i18n>per month</ng-container></ng-container
    >
    <ng-container *ngIf="strategy === 'per-job'" i18n>Variable price per job. No upfront costs.</ng-container>
    <ng-container *ngIf="strategy === 'per-website'" i18n>Variable price per website. No upfront costs.</ng-container>
    <ng-container *ngIf="strategy === 'per-document'" i18n>Variable price per document. No upfront costs.</ng-container>
    <ng-container *ngIf="strategy === 'percent'" i18n>Variable percentage of sales</ng-container>
    <ng-container *ngIf="strategy === 'per-owner'" i18n>$19.99 first owner, $9.99 for each next owner</ng-container>
  </ng-template>
</ng-container>

<i class="far fa-spin fa-spinner text-xl text-info" *ngIf="isLoading"></i>
